import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import "react-tabs/style/react-tabs.css"
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import axios from 'axios'
import auth from './utils/auth'
import helper from './utils/helper'
import pageLoading from './utils/pageLoading'


const allowedKeys = ["detail", "message", "non_field_errors", "error", "msg", "status", "code", "message_code", "mensagem", "response", "resposta"]

const respostaMelhorada = {
    "invalid_grant": "Não foi possivel identificar usuario e senha. Por favor, limpe o cache da sessão, atualize a página e tente novamente.",
    "invalid_request": "Não conseguimos identificar suas credenciais. Por favor, verifique se você digitou seu nome de usuário e senha corretamente e tente novamente."
}

const processErrorMessage = (errorData) => {
    let stringKeys = Object.keys(errorData)
    let messages = []
    
    // vai percorrer tudo encontrar chaves validas e montar uma nova resposta formatada para o frontend.
    stringKeys.forEach(key => {
        let val = errorData[key]
        
        if (!allowedKeys.includes(key)) {
            return
        }
        
        let text = ''
        
        if (val === null || val === undefined) {
            text = ""
        } else if (typeof val === "string") {
            text = val
        } else if (Array.isArray(val)) {
            text = val.join('; ')
        } else if (typeof val === "object") {
            if ('detail' in val && typeof val.detail === 'string') {
                text = val.detail
            } else {
                text = JSON.stringify(val)
            }
        } else {
            text = String(val)
        }

        let message = ""
        if (text in respostaMelhorada) {
            message = respostaMelhorada[text]
        } else {
            if (text) {
                message = `<li>${text.replace('false', 'Inválido').replace('true', 'Válido')}</li><br>`
            }
        }
        if (message) {
            messages.push(message)
        }
    })

    return messages.length > 0 ? messages.join('') : ''
}

const showAviso = (message, callbackClose = null) => {
    helper.dispatchEvent("showAviso", {
        message,
        callbackClose: callbackClose || (() => window.close()),
        callbackLabelClose: "Fechar"
    })
}

axios.interceptors.request.use((config) => {
    if (!pageLoading.shouldSkip(config)) {
        config.__pageLoading = true
        pageLoading.start()
    }
    return config
})

axios.interceptors.response.use((response) => {
    if (response.config?.__pageLoading) {
        pageLoading.done()
    }
    return response
}, (error) => {
    if (error?.config?.__pageLoading) {
        pageLoading.done()
    }
    return Promise.reject(error)
})

axios.interceptors.response.use((response) => response, (error) => {
    const status = error?.response?.status
    
    if (status === 401) {
        // auth.refreshToken() deduplica chamadas concorrentes internamente,
        // então múltiplos 401 simultâneos (várias requisições em paralelo)
        // resultam em uma única renovação de token, evitando criar várias
        // sessões no backend. Não usar setInterval aqui: cada 401 já dispara
        // sua própria tentativa e refreshToken() recarrega a página em caso
        // de sucesso ou limpa o storage em caso de falha.
        auth.refreshToken(error)
        return Promise.reject(error)
    }

    if (status === 404) {
        showAviso("Registro não encontrado.")
        return Promise.reject(error)
    }
    
    if ([403, 405].includes(status)) {
        showAviso("Seu usuário não possui permissão para acessar este registro.")
        return Promise.reject(error)
    }
    
    if (status === 500) {
        showAviso("Alguma informação pode estar incorreta, verifique as informações, atualize a página e tente novamente.")
        return Promise.reject(error)
    }

    if (error?.response?.data) {
        const messageToShow = processErrorMessage(error.response.data)
        if (messageToShow) {
            showAviso(messageToShow)
        }
    } else {
        showAviso("Alguma informação pode estar incorreta, verifique as informações, atualize a página e tente novamente.")
    }

    return Promise.reject(error)
})

createRoot(document.getElementById('root')).render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
)
